"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onBrowserHydrateRenderContext = void 0;
var tslib_1 = require("tslib");
var hook_context_1 = require("../hook-context");
var hook_runner_1 = require("../hook-runner");
/**
 * Take serialized state from server-side render and hydrate appropriate state objects
 * in the browser.
 *
 * @param plugins
 * @param context
 */
var onBrowserHydrateRenderContext = function (plugins, context) {
  return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var appData, state, _a, getAppData, setAppData, hookArgs;
    return tslib_1.__generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          appData = context.appData, state = context.state;
          _a = (0, hook_context_1.buildAppData)(appData), getAppData = _a.getAppData, setAppData = _a.setAppData;
          hookArgs = (0, hook_context_1.buildHookContext)('onBrowserHydrateRenderContext', tslib_1.__assign(tslib_1.__assign({}, context), {
            getAppData: getAppData,
            setAppData: setAppData,
            hydratedState: {}
          }));
          return [4 /*yield*/, (0, hook_runner_1.runHook)(plugins, 'onBrowserHydrateRenderContext', hookArgs, {
            pre: function (args, plugin) {
              var hydratedState = state[plugin.name];
              return tslib_1.__assign(tslib_1.__assign({}, args), {
                hydratedState: hydratedState
              });
            }
          })];
        case 1:
          _b.sent();
          return [2 /*return*/, {
            appData: getAppData(),
            result: null
          }];
      }
    });
  });
};
exports.onBrowserHydrateRenderContext = onBrowserHydrateRenderContext;